<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Utilisateurs</h6>
                <a class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalUser" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess"><i class="fas fa-plus fa-md"></i></a>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableUser" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Nom</th>
                        <th>Identifiant</th>
                        <th class="d-none">Role</th>
                        <th>Privilège</th>
                        <th>Statut</th>
                        <th class="d-none">Assessor</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Nom</th>
                        <th>Identifiant</th>
                        <th class="d-none">Role</th>
                        <th>Privilège</th>
                        <th>Statut</th>
                        <th class="d-none">Assessor</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in users" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{item.first_name}}</td>
                        <td>{{item.username}}</td>
                        <td class="d-none">{{item.role}}</td>
                        <td>{{item.privilege}}</td>
                        <td>{{getStatusName(item.is_active)}}</td>
                        <td class="d-none">{{item.assessor}}</td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalUser" v-on:click="viewUser(item.id)" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalUser" v-on:click="viewUser(item.id)" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-info shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#activateModalUser" v-on:click="viewUser(item.id)" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
                          <i class="fas fa-toggle-on fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-dark shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#passwordModalUser" v-on:click="viewUser(item.id)" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
                          <i class="fas fa-key fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalUser" v-on:click="viewUser(item.id)" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal User -->
    <div class="modal fade" id="addModalUser" tabindex="-1" role="dialog" aria-labelledby="ModalUserLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addUserForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalUserLabel">Ajouter Utilisateur</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Assessor</label>
                  <select class="custom-select mb-2" v-model="assessor1" name="assessor1" required>
                    <option value="null">Aucun</option>
                    <option v-for="(item, index) in assessors" v-bind:key="item.id" v-bind:value="item.id">{{item.id}} - {{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Rôle</label>
                  <select class="custom-select mb-2" v-model="role1" name="role1" required>
                    <option v-for="(item, index) in roles" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="first_name1" name="first_name1" required>
                </div>
                <div class="col-sm-6">
                  <label>Identifiant</label>
                  <input type="text" class="form-control mb-2" v-model="username1" name="username1" required>
                </div>
                <div class="col-sm-6">
                  <label>Mot de Passe</label>
                  <input type="password" id="password1" class="form-control mb-2" v-model="password1" name="password1" required>
                </div>
                <div class="col-sm-6">
                  <label>Privilège</label>
                  <select class="custom-select mb-2" v-model="privilege1" name="privilege1" required>
                    <option value="business">business</option>
                    <option value="area">area</option>
                    <option value="country">country</option>
                    <option value="site">site</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Business Units</label>
                  <select class="custom-select mb-2" v-model="business_units1" name="business_units1" multiple>
                    <option v-for="(item, index) in business_units" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Activités</label>
                  <select class="custom-select mb-2" v-model="activities1" name="activities1" multiple>
                    <option v-for="(item, index) in activities" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Régions</label>
                  <select class="custom-select mb-2" v-model="areas1" name="areas1" multiple>
                    <option v-for="(item, index) in areas" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Pays</label>
                  <select class="custom-select mb-2" v-model="countries1" name="countries1" multiple>
                    <option v-for="(item, index) in countries" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Entreprises</label>
                  <select class="custom-select mb-2" v-model="companies1" name="companies1" multiple>
                    <option v-for="(item, index) in companies" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Sites</label>
                  <select class="custom-select mb-2" v-model="sites1" name="sites1" multiple>
                    <option v-for="(item, index) in sites" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addUser" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addUserProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal User -->
    <div class="modal fade" id="viewModalUser" tabindex="-1" role="dialog" aria-labelledby="ModalUserLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalUserLabel">Utilisateur [#<span>{{indexUser+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Assessor</th>
                  <td>{{assessor2}}</td>
                </tr>
                <tr>
                  <th scope="row">Rôle</th>
                  <td>{{role2}}</td>
                </tr>
                <tr>
                  <th scope="row">Identifiant</th>
                  <td>{{username2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{first_name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Privilège</th>
                  <td>{{privilege2}}</td>
                </tr>
                <tr>
                  <th scope="row">Business Units</th>
                  <td>{{business_units2}}</td>
                </tr>
                <tr>
                  <th scope="row">Régions</th>
                  <td>{{areas2}}</td>
                </tr>
                <tr>
                  <th scope="row">Pays</th>
                  <td>{{countries2}}</td>
                </tr>
                <tr>
                  <th scope="row">Entrepries</th>
                  <td>{{companies2}}</td>
                </tr>
                <tr>
                  <th scope="row">Sites</th>
                  <td>{{sites2}}</td>
                </tr>
                <tr>
                  <th scope="row">Activités</th>
                  <td>{{activities2}}</td>
                </tr>
                <tr>
                  <th scope="row">Statut</th>
                  <td>{{getStatusName(statut2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal User -->
    <div class="modal fade" id="editModalUser" tabindex="-1" role="dialog" aria-labelledby="ModalUserLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editUserForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalUserLabel">Modifier Utilisateur [#<span>{{indexUser+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Assessor</label>
                  <select class="custom-select mb-2" v-model="assessor3" name="assessor3" required>
                    <option value="null">Aucun</option>
                    <option v-for="(item, index) in assessors" v-bind:key="item.id" v-bind:value="item.id">{{item.id}} - {{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Rôle</label>
                  <select class="custom-select mb-2" v-model="role3" name="role3" required>
                    <option v-for="(item, index) in roles" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="first_name3" name="first_name3" required>
                </div>
                <div class="col-sm-6">
                  <label>Identifiant</label>
                  <input type="text" class="form-control mb-2" v-model="username3" name="username3" required>
                </div>
                <div class="col-sm-12">
                  <label>Privilège</label>
                  <select class="custom-select mb-2" v-model="privilege3" name="privilege3" required>
                    <option value="business">business</option>
                    <option value="area">area</option>
                    <option value="country">country</option>
                    <option value="site">site</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Business Units</label>
                  <select class="custom-select mb-2" v-model="business_units3" name="business_units3" multiple>
                    <option v-for="(item, index) in business_units" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Activités</label>
                  <select class="custom-select mb-2" v-model="activities3" name="activities3" multiple>
                    <option v-for="(item, index) in activities" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Régions</label>
                  <select class="custom-select mb-2" v-model="areas3" name="areas3" multiple>
                    <option v-for="(item, index) in areas" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Pays</label>
                  <select class="custom-select mb-2" v-model="countries3" name="countries3" multiple>
                    <option v-for="(item, index) in countries" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Entreprises</label>
                  <select class="custom-select mb-2" v-model="companies3" name="companies3" multiple>
                    <option v-for="(item, index) in companies" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>

                <div class="col-sm-6">
                  <label>Sites</label>
                  <select class="custom-select mb-2" v-model="sites3" name="sites3" multiple>
                    <option v-for="(item, index) in sites" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editUser" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editUserProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Activate Modal User -->
    <div class="modal fade" id="activateModalUser" tabindex="-1" role="dialog" aria-labelledby="ModalUserLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="activateUserForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalUserLabel">Modifier Statut Utilisateur [#<span>{{indexUser+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-12">
                  <label>Satatut</label>
                  <select class="custom-select mb-2" v-model="is_active4" name="is_active4" required>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-info text-uppercase w-50" href="javascript:(0)" v-on:click="activateUser" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="activateUserProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Password Modal User -->
    <div class="modal fade" id="passwordModalUser" tabindex="-1" role="dialog" aria-labelledby="ModalUserLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="passwordUserForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalUserLabel">Modifier Mot de Passe Utilisateur [#<span>{{indexUser+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-12">
                  <label>Nouveau Mot de Passe</label>
                  <input type="password" class="form-control mb-2" v-model="password5" name="password5" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-dark text-uppercase w-50" href="javascript:(0)" v-on:click="passwordUser" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="passwordUserProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Delete Modal User -->
    <div class="modal fade" id="deleteModalUser" tabindex="-1" role="dialog" aria-labelledby="ModalUserLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalUserLabel">Supprimer Utilisateur [#<span>{{indexUser+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer cet utilisateur ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteUser" v-bind:disabled="addUserProcess || editUserProcess || activateUserProcess || passwordUserProcess || deleteUserProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteUserProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      client: {},
      role: {},
      user: {},
      indexUser: '',
      roles: [],
      assessors: [],
      status: ["Activé","Désactivé"],
      areas: [],
      countries: [],
      companies: [],
      sites: [],
      business_units: [],
      activities: [],
      users: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addUserProcess: false,
      viewUserProcess: false,
      editUserProcess: false,
      activateUserProcess: false,
      passwordUserProcess: false,
      deleteUserProcess: false,
      first_name1:'',
      role1:'',
      assessor1:'',
      username1:'',
      password1:'',
      privilege1:'',
      business_units1:[],
      activities1:[],
      areas1:[],
      countries1:[],
      companies1:[],
      sites1:[],
      id2:'',
      privilege2:'',
      first_name2:'',
      username2:'',
      role2:'',
      assessor2:'',
      business_units2:'',
      activities2:'',
      areas2:'',
      companies2:'',
      countries2:'',
      sites2:'',
      statut2:'',      
      first_name3:'',
      role3:'',
      assessor3:'',
      username3:'',
      privilege3:'',
      business_units3:[],
      activities3:[],
      areas3:[],
      countries3:[],
      companies3:[],
      sites3:[],
      is_active4:'',
      password5: '',
      isAdmin: false,
      dTableUser: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {
        this.dTableUser = $('#dataTableUser').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            { 'width': '180' }
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true
        })
        this.user = {
          'id': '',
          'first_name':'',
          'last_name':'',
          'username':'',
          'password':'',
          'role':'',
          'is_active':'',
          'client':'',
          'assessor':''
        }
        this.first_name1 = ''
        this.role1 = ''
        this.assessor1 = ''
        this.username1 = ''
        this.password1 = ''
        this.privilege1 = ''
        this.business_units1 = []
        this.activities1 = []
        this.areas1 = []
        this.countries1 = []
        this.companies1 =  []
        this.sites1 =  []
        this.id2= ''
        this.privilege2 = ''
        this.first_name2 = ''
        this.username2 = ''
        this.role2 = ''
        this.assessor2 = ''
        this.business_units2 = []
        this.activities2 = []
        this.areas2 = []
        this.countries2 = []
        this.companies2 = []
        this.sites2 = []
        this.statut2 = ''
        this.first_name3 = ''
        this.role3 = ''
        this.assessor3 = ''
        this.username3 = ''
        this.privilege3 = ''
        this.business_units3 = []
        this.activities3 = []
        this.areas3 = []
        this.countries3 = []
        this.companies3 =  []
        this.sites3 =  []
        this.is_active4 = ''
        this.password5 = ''
      }, 50)
    },
    //Sélectionner toutes les régions (Base de données)
    getAreas () {
      axios.get(this.apiUrl+'/areas', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.areas = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner tous les pays (Base de données)
    getCountries () {
      axios.get(this.apiUrl+'/countries', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.countries = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner toutes les entreprises (Base de données)
    getCompanies () {
      axios.get(this.apiUrl+'/companies', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.companies = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner tous les sites (Base de données)
    getSites () {
      axios.get(this.apiUrl+'/sites', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.sites = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner toutes les business units (Base de données)
    getBussinessUnits () {
      axios.get(this.apiUrl+'/business_units', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.business_units = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner toutes les activités (Base de données)
    getActivities () {
      axios.get(this.apiUrl+'/activities', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.activities = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner tous les rôles (Base de données)
    getRoles () {
      axios.get(this.apiUrl+'/roles', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.roles = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner tous les assessor (Base de données)
    getAssessors () {
      axios.get(this.apiUrl+'/assessors', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.assessors = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Sélectionner tous les utilisateurs (Base de données)
    getUsers () {
      axios.get(this.apiUrl+'/users', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.users = res.data
          this.progress += 1
          if (this.progress === 9) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Ajouter un utilisateur
    addUser () {
      if ($('#addUserForm').isValid()) {
        this.addUserProcess = true
        let assessor = (this.assessor1 !== 'null') ? this.assessor1 : null
        let user = {
          id: this.users.length + 1,
          assessor_id: assessor,
          role_id: this.role1,
          username: this.username1,
          password: this.password1,
          first_name: this.first_name1,
          last_name: "",
          privilege: this.privilege1,
          business_units: this.business_units1,
          areas: this.areas1,
          countries: this.countries1,
          companies: this.companies1,
          sites: this.sites1,
          activity: this.activities1,
          is_active: 1
        }
        axios.post(this.apiUrl+'/users', user, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.users.push(user)
            this.dTableUser.destroy()
            this.init()
          }
          $('#addModalUser').modal('hide')
          this.addUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalUser').modal('hide')
          this.addUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Sélectionner un utilisateur (Local)
    viewUser (id) {
      this.user = this.users.filter(function (item) {
        return item.id === id
      })[0]
      this.indexUser = this.users.indexOf(this.user)
      this.id2= this.user.id
      this.first_name2 = this.user.first_name
      this.username2 = this.user.username
      this.assessor2 = this.user.assessor_id
      this.role2 = this.user.role_id
      this.privilege2 = this.user.privilege
      this.activities2 = this.user.activity
      this.business_units2 = this.user.business_units
      this.areas2 = this.user.areas
      this.countries2 = this.user.countries
      this.companies2 = this.user.companies
      this.sites2 = this.user.sites
      this.statut2 = this.user.is_active
      this.first_name3 = this.user.first_name
      this.role3 = this.user.role_id
      this.assessor3 = this.user.assessor_id
      this.username3 = this.user.username
      this.privilege3 = this.user.privilege
      this.business_units3 = this.user.business_units
      this.activities3 = this.user.activity
      this.areas3 = this.user.areas
      this.countries3 = this.user.countries
      this.companies3 =  this.user.companies
      this.sites3 =  this.user.sites
      this.is_active4 = +this.user.is_active
    },
    //Modifier un utilisateur
    editUser () {
      if ($('#editUserForm').isValid()) {
        var id = this.user.id
        let assessor = (this.assessor3 !== 'null') ? this.assessor3 : null
        this.editUserProcess = true
        axios.put(this.apiUrl+'/users/' + id, {
          assessor_id: assessor,
          role_id: this.role3,
          username: this.username3,
          password: this.user.password,
          first_name: this.first_name3,
          last_name: "",
          privilege: this.privilege3,
          business_units: this.business_units3,
          areas: this.areas3,
          countries: this.countries3,
          companies: this.companies3,
          sites: this.sites3,
          activity: this.activities3,
          is_active: this.user.is_active
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.user.first_name = this.first_name3
            this.user.role = this.role3
            this.user.assessor = this.assessor
            this.user.username = this.username3
            this.user.privilege = this.privilege3
            this.user.business_units = this.business_units3
            this.user.activity = this.activities3
            this.user.areas = this.areas3
            this.user.countries = this.countries3
            this.user.companies =  this.companies3
            this.user.sites =  this.sites3
            this.users[this.indexUser] = this.user
            this.dTableUser.destroy()
            this.init()
          }
          $('#editModalUser').modal('hide')
          this.editUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalUser').modal('hide')
          this.editUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Modifier statut d’un utilisateur (Activer || Désactivé)
    activateUser () {
     if ($('#activateUserForm').isValid()) {
        var id = this.user.id
        var user = this.user
        user.is_active = parseInt(this.is_active4)
        this.activateUserProcess = true
        axios.put(this.apiUrl+'/users/' + id, user, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.user.is_active = parseInt(this.is_active4)
            this.users[this.indexUser] = this.user
            this.dTableUser.destroy()
            this.init()
          }
          $('#activateModalUser').modal('hide')
          this.activateUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#activateModalUser').modal('hide')
          this.activateUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }      
    },
    //Modifier mot de passe d’un utilisateur
    passwordUser () {
     if ($('#passwordUserForm').isValid()) {
        var id = this.user.id
        var user = this.user
        user.password = this.password5
        this.passwordUserProcess = true
        axios.put(this.apiUrl+'/users/' + id, user, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.user.password = res.data.password
            this.users[this.indexUser] = this.user
          }
          $('#passwordModalUser').modal('hide')
          this.passwordUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#passwordModalUser').modal('hide')
          this.passwordUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }      
    },
    //Supprimer un utilisateur
    deleteUser () {
      var id = this.user.id
      this.deleteUserProcess = true
      axios.delete(this.apiUrl+'/users/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.users.splice(this.indexUser, 1)
            this.dTableUser.destroy()
            this.init()
          }
          $('#deleteModalUser').modal('hide')
          this.deleteUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#deleteModalUser').modal('hide')
          this.deleteUserProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
    },
    //Sélectionner rôle (Local)
    getRoleName (id) {
      var role = this.roles.filter(function (item) {
        return item.id === id
      })
      return role[0].name
    },
    //Sélectionner site (Local)
    getSiteName (id) {
      var site = this.sites.filter(function (item) {
        return item.id === id
      })[0]
      return site[0].name
    },
    //Sélectionner nom statut (Local)
    getStatusName (status) {
      if (status === 0) {
        return this.status[1]
      } else {
        return this.status[0]
      }
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getRoles()
    this.getUsers()
    this.getAssessors()
    this.getAreas()
    this.getCountries()
    this.getCompanies()
    this.getSites()
    this.getActivities()
    this.getBussinessUnits()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User.vue